import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'app-add-category-dialog',
  templateUrl: './addCategoryDialog.component.html'
})
export class AddCategoryDialogComponent {
  categoryForm: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AddCategoryDialogComponent>
  ) {
    this.categoryForm = this._formBuilder.group({
      name: ['', Validators.required]
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.categoryForm.valid) {
      this.dialogRef.close(this.categoryForm.value.name);
    }
  }
}
